module.exports = __webpack_public_path__ + "static/media/total-products-blue.dd2cc80c.svg";